/**
 * @name handleClientSideSearch
 * @desc Seach data set in client side.
 * @param {array} dataSet
 * @param {object} searchString
 * @return data
 */

export default function handleClientSideSearch(dataSet, searchString) {
	const regExp = new RegExp(
		searchString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
		'gi'
	);

	return [...dataSet].filter(o => {
		const objectAsString = Object.values(o)
			.filter(value => value)
			.map(value => {
				if (typeof value === 'string') {
					return value.toLowerCase();
				}

				return value;
			}).join(' ');

		return `/${objectAsString}/`.match(regExp);
	});
}